import type { GuideDefinition } from './types';

// Employee Setup Guide — lighter than the employer's: what Swiss household employment
// means for you, your insurance/benefits, your rights, and multi-employer notes. Like the
// employer guide it covers what employment means, not how to drive the app (a feature tour
// is a separate, later concern). Personalized where useful (accident/BVG applicability,
// AHV presence).

export const employeeGuide: GuideDefinition = {
  id: 'employee',
  sections: [
    {
      id: 'meaning',
      icon: 'fa-hand-holding-heart',
      titleKey: 'guide.employee.meaning.title',
      descKey: 'guide.employee.meaning.desc',
      steps: [
        {
          id: 'understand',
          icon: 'fa-circle-info',
          type: 'info',
          titleKey: 'guide.employee.meaning.understand.title',
          bodyKey: 'guide.employee.meaning.understand.body',
          bulletKeys: [
            'guide.employee.meaning.understand.b1',
            'guide.employee.meaning.understand.b2',
            'guide.employee.meaning.understand.b3',
          ],
          manualCheck: true,
        },
        {
          id: 'ahv',
          icon: 'fa-id-card',
          type: 'info',
          titleKey: 'guide.employee.meaning.ahv.title',
          bodyKey: 'guide.employee.meaning.ahv.body',
          autoDeriveKey: 'hasAhvNumber',
          manualCheck: true,
        },
      ],
    },
    {
      id: 'insurance',
      icon: 'fa-shield-heart',
      titleKey: 'guide.employee.insurance.title',
      descKey: 'guide.employee.insurance.desc',
      steps: [
        {
          id: 'benefits',
          icon: 'fa-briefcase-medical',
          type: 'info',
          titleKey: 'guide.employee.insurance.benefits.title',
          bodyKey: 'guide.employee.insurance.benefits.body',
          bulletKeys: [
            'guide.employee.insurance.benefits.b1',
            'guide.employee.insurance.benefits.b2',
            'guide.employee.insurance.benefits.b3',
          ],
          manualCheck: true,
        },
      ],
    },
    {
      id: 'rights',
      icon: 'fa-scale-balanced',
      titleKey: 'guide.employee.rights.title',
      descKey: 'guide.employee.rights.desc',
      extra: 'documents',
      steps: [
        {
          id: 'know',
          icon: 'fa-list-check',
          type: 'info',
          titleKey: 'guide.employee.rights.know.title',
          bodyKey: 'guide.employee.rights.know.body',
          bulletKeys: [
            'guide.employee.rights.know.b1',
            'guide.employee.rights.know.b2',
            'guide.employee.rights.know.b3',
          ],
          manualCheck: true,
        },
      ],
    },
    {
      id: 'multiple',
      icon: 'fa-people-group',
      titleKey: 'guide.employee.multiple.title',
      descKey: 'guide.employee.multiple.desc',
      steps: [
        {
          id: 'note',
          icon: 'fa-circle-info',
          type: 'info',
          titleKey: 'guide.employee.multiple.note.title',
          bodyKey: 'guide.employee.multiple.note.body',
          manualCheck: true,
        },
      ],
    },
    {
      id: 'done',
      icon: 'fa-check',
      titleKey: 'guide.employee.done.title',
      steps: [
        {
          id: 'done',
          icon: 'fa-flag-checkered',
          type: 'info',
          titleKey: 'guide.employee.done.done.title',
          bodyKey: 'guide.employee.done.done.body',
        },
      ],
    },
  ],
};
